import { useState, useEffect, useRef } from "react";
import styles from "./Header.module.css";
import engLogo2026 from "../../assets/images/eng_logo.svg";
import engLogo2025 from "../../assets/images/eng_logo_2025.svg";
import korLogo2025 from "../../assets/images/logo.svg";
import Navigation from "../Navigation/Navigation.js";
import { useTranslation } from "react-i18next";
import { useYear } from "../../context/YearContext.js";

// 연도·언어별 로고 (2026 한글 로고는 없어서 2026은 한국어도 영문 로고)
const LOGOS = {
  2025: { ko: korLogo2025, en: engLogo2025 },
  2026: { ko: engLogo2026, en: engLogo2026 },
};

const Header = () => {
  const { t, i18n } = useTranslation();
  const { year, setYear, years } = useYear();
  const [showYearOptions, setShowYearOptions] = useState(false);
  const yearRef = useRef(null);
  
  const tabs = [
    { path: "match-status", label: t("nav.match-status") }, // 경기 현황
    { path: "group-formation", label: t("nav.group-formation") }, // 원작대
    { path: "match-results", label: t("nav.match-results") }, // 경기 집계 현황
  ];
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // 언어에 따라 로고 선택
  const logos = LOGOS[year] || LOGOS[2026];
  const currentLogo = i18n.language === "ko" ? logos.ko : logos.en;
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (yearRef.current && !yearRef.current.contains(event.target)) {
        setShowYearOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectYear = (selectedYear) => {
    setYear(selectedYear);
    setShowYearOptions(false);
  };

  return (
    <header className={styles.header}>
      {/* logo */}
      <div className={styles.logo}>
        <img src={currentLogo} alt="울산세계궁도대회 로고" />
      </div>

      {/* navigation */}
      <Navigation tabs={tabs} basePath="" variant="main" />

      <div className={styles.rightSection}>
        {/* site */}
      <div className={styles.headerRight}>
        <div
          className={styles.yearSelect}
          onClick={() => setShowYearOptions((prev) => !prev)}
          ref={yearRef}
        >
          <span className={styles.yearLabel}>{year}</span>
          <ul
            className={`${styles.yearOptions} ${
              showYearOptions ? styles.show : styles.hide
            }`}
          >
            {years.map((item) => (
              <li
                key={item}
                className={`${styles.yearOption} ${
                  year === item ? styles.activeYear : ""
                }`}
                style={{ "--option-gradient": `var(--gradient-${item})` }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectYear(item);
                }}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.website}>
          <a
            href="http://xn--989a1nf0lnwar68blxat5zm15a.com/" // 울산세계궁도대회.com
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("common.site")}
          </a>
        </div>

        {/* language */}
        <div className={styles.languageSwitch} data-lang={i18n.language}>
          <button
            className={`${styles.langButton} ${
              i18n.language === "ko" ? styles.active : ""
            }`}
            onClick={() => changeLanguage("ko")}
          >
            한국어
          </button>
          <button
            className={`${styles.langButton} ${
              i18n.language === "en" ? styles.active : ""
            }`}
            onClick={() => changeLanguage("en")}
          >
            English
          </button>
        </div>
      </div>
    </div>
    </header>
  );
}
export default Header;
